import { Inject, Injectable, InjectionToken } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';

export const ALLOW_MULTI_SELECT = new InjectionToken<boolean>('allowMultiSelect', {
  providedIn: 'root',
  factory: () => true // default value
});

export const INITIAL_SELECTION = new InjectionToken<unknown[]>('initialSelection', {
  providedIn: 'root',
  factory: () => []
});

/**
 * A generic selection service that provides SelectionModel management for any item type.
 */
@Injectable()
export class SelectionService<T> {
  public readonly selection: SelectionModel<T>;
  private currentDataset: T[] = [];

  constructor(
    @Inject(ALLOW_MULTI_SELECT) allowMultiSelect: boolean,
    @Inject(INITIAL_SELECTION) initialSelection: T[]
  ) {
    this.selection = new SelectionModel<T>(allowMultiSelect, initialSelection);
  }

  /** Sets the dataset without affecting selection */
  public setDataset(newDataset: T[]): void {
    this.currentDataset = newDataset;
  }

  /** Clears the current selection without affecting the dataset */
  public clearSelection(): void {
    this.selection.clear();
  }

  /** Returns true if all items in the current dataset are selected. */
  public isAllSelected(): boolean {
    return (this.selection.selected.length === this.currentDataset.length) && this.currentDataset.length > 0;
  }

  /** Selects all items if not all are selected; otherwise, clears selection. */
  public toggleAll(): void {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.selection.select(...this.currentDataset);
    }
  }
}